
import ROUTES from "../Routes/routesContants"
import { LogError } from "../../helpers/logger"

/* Assessments actions */
export function handleScheduledAssessment(actionContext, navigateHook) {
  const scheduledAssessmentActionUrl = "#ScheduledAssessment"
  let payload = "{}"

  if (actionContext?.primaryActionUrl === scheduledAssessmentActionUrl) {
    payload = actionContext?.primaryActionPayload
  } else if (
    actionContext?.secondaryActionUrl === scheduledAssessmentActionUrl
  ) {
    payload = actionContext?.secondaryActionPayload
  }

  if (payload !== "{}")
    if (payload) {
      let cleanPayload = payload
        .replaceAll(`"`, "")
        .replaceAll("\\u0022", `"`)
        .replaceAll("\\", "")

      if (
        cleanPayload[0] === `"` &&
        cleanPayload[cleanPayload.length - 1] === `"`
      ) {
        cleanPayload = cleanPayload.substring(1, cleanPayload.length - 1)
      }

      const shaPayload = JSON.parse(cleanPayload)
      if (!shaPayload?.participant_id) {
        LogError("Scheduled assessment: malformed payload, no participant specified")
      }
      else {
        navigateHook(ROUTES.PARTICIPANT_ASSESSMENTS, {
          replace: true,
          state: {
            taskId: shaPayload?.taskId,
            participant_id: shaPayload.participant_id,
            organization_id: actionContext.groupId,
          },
        })
      }
    }
    else {
      navigateHook(ROUTES.PARTICIPANT_ASSESSMENTS, {
        replace: true,
        state: { page: "schedule" },
      })
    }
}

/* TR Chat actions */
export function handleIncomingChatMessage(actionContext, navigateHook) {
  return navigateHook(
    `${ROUTES.PARTICIPANT_TELERECOVERY_SERVICES}/chat`, {
    state: {
      peerId: actionContext.staffId
    }
  }
  )
}

/* Referrals actions */
export function handleReferralNavigation(actionContext, navigateHook) {
  let path = actionContext.primaryActionUrl

  if (actionContext.primaryActionPayload) {
    const payload = actionContext.primaryActionPayload
      .replaceAll('"', "")
      .split("\\u0026")[0]
    const editReferralLink = ROUTES.PARTICIPANT_REFERRALS_DETAIL
    path = `${editReferralLink.substring(
      0,
      editReferralLink.lastIndexOf("/")
    )}/${payload}`
  }

  navigateHook(path, {
    //replace: true,
    state: {
      previousTitle: "Referrals",
      previousRoute: "/participant/referrals",
    }
  })
}